// extracted by mini-css-extract-plugin
module.exports = {"MobileDisclimer":"MobileDisclimer_MobileDisclimer__ASAKD"};